import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { Observable } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import { MenuService } from "../../services/menu.service";
import { MatMenu, MatSidenav } from "@angular/material";
import { ToolPanelControlComponent } from "../controls/tool-panel/tool-panel-control.component";
import { NotificationToastService } from "../../services/notification-toast.service";
import { EnvironmentPresetService } from "../../services/environment-preset/environment-preset.service";

@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.css"],
})
export class NavMenuComponent implements OnInit {
  version: string;
  showFiller: boolean;
  isHandset: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset,
  );
  @ViewChild("toolPanel", { static: false })
  toolPanel: ToolPanelControlComponent;
  @ViewChild("endSidenav", { static: false }) endSidenav: MatSidenav;
  toolName: string;

  constructor(
    private menuService: MenuService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private environmentPresetService: EnvironmentPresetService,
    private authService: AuthService,
  ) {}
  ngOnInit(): void {}

  txControlEnabled(): boolean {
    return this.authService.txControlEnabled();
  }

  canTest(): boolean {
    return this.authService.canTest();
  }

  isExtraccionistaModality(): boolean {
    return this.authService.isExtraccionistaModality();
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  get getQRCode(): string {
    let code: string = null;
    if (this.menuService.currentQrCode !== "") {
      code = this.menuService.currentQrCode;
    }
    return code;
  }

  openTool(toolTag: string): void {
    this.toolName = this.toolPanel.initTool(toolTag);
    this.endSidenav.toggle();
  }

  findOrderControlDialg(): void {
    this.router.navigate(["billing-order-do", new Date().getTime()]);
  }

  isMenuVisible(matMenu: MatMenu): boolean {
    // tslint:disable-next-line: deprecation
    return matMenu.items && matMenu.items.length > 0;
  }

  isVisible(): boolean {
    // tslint:disable-next-line: deprecation
    return this.menuService.isVisible();
  }

  isValidMenuTag(tag: string): boolean {
    return this.authService.isValidMenuTag(tag);
  }

  get getUserInfo(): string {
    return (
      this.authService.getFullName() +
      " - " +
      this.authService.getSector() +
      " - " +
      this.authService.getCenter()
    );
  }

  get getMenuTitle(): string {
    let title = "";
    if (this.menuService.currentTitle !== "") {
      title = this.menuService.currentTitle;
    }
    if (this.menuService.currentSubTitle !== "") {
      title = title + "-" + this.menuService.currentSubTitle;
    }
    return title;
  }

  isOldVersion(): boolean {
    return this.authService.isOldVersion();
  }

  getVersion() {
    return this.authService.getVersion();
  }

  isCT() {
    return this.environmentPresetService.getPreset().isCT;
  }

  get getCardName(): string {
    return this.authService.getCardName();
  }

  logOut(): void {
    this.authService.logOut();
    this.router.navigate(["login"]);
  }

  changePass(): void {
    this.router.navigate(["change-pass"]);
  }
}
